/** 本周练习榜: this week's practice effort in the trainee's store. */

import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { EmptyView } from '@euler/components/EmptyView';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { ActivityIndicator } from 'react-native';
import { LeaderboardView } from '../../progress/LeaderboardView';
import { useCoachingLeaderboard } from '../../progress/functions/useCoachingLeaderboard';

export const CoachingLeaderboardScreen = wrapNavigatorScreen(
  () => {
    const { rpx } = useResponsiveContext();
    const { board, failed, reload } = useCoachingLeaderboard();
    if (failed && !board)
      return <EmptyView message="练习榜暂时没加载出来" onRetry={reload} />;
    if (!board)
      return (
        <ActivityIndicator
          color={aiColors.primary}
          style={{ marginTop: rpx(48) }}
        />
      );
    return <LeaderboardView board={board} failed={failed} onRefresh={reload} />;
  },
  { title: '本周练习榜' },
);
